<template>
  <v-container fluid>
    <main-header-plat-a />
    <main-header-plat-b :navBItems="schema.navBItems" />
    <v-overlay v-model="overlayCal" class="d-flex align-end" style="z-index: 1000; position: absolute">
      <v-row class="mb-2 ml-16" style="width: 200px">
        <v-col cols="12" class="ma-0 pa-0 text-primary">
          <span class="d-flex text-subtitle-2 justify-center">Calculando</span>
        </v-col>
        <v-col cols="12" class="d-flex mx-auto justify-center">
          <v-progress-circular
            class="mx-auto"
            color="primary"
            indeterminate
            rounded
            height="7"
          ></v-progress-circular>
        </v-col>
      </v-row>
    </v-overlay>
    <v-row class="flex-sm-nowrap">
      <div class="barLateral">
        <v-nav-draw-anam
          :coDateForm="schema.coDateForm"
          :anamIndex="anamIndex"
          :anamGroupShow="anamGroupShow"
        />
      </div>
      <div class="contentCentral">
        <v-card-form-anam-co
          :anamRoute="schema.anamRoute"
          :schemaCoDate="schema.schemaCoDate"
          :modelCoDate="coModel.coInfo"
          :handleEvents="handleEvents"
          :observerHCP="observerHCP"
        />
        <v-card class="contentCardCentral secundary5 justify-center" flat>
          <v-slides-co
            :schemaForm="schema.schemaFormItems"
            :coBtnIcons="schema.coBtnIcons"
            :testDate="schema.testDate"
            :modelForm="coModel.modelForm"
            :handleEvents="handleEvents"
            :ageVerifAndSave="ageVerifAndSave"
            :btnResult="btnResult"
            :observerHCP="observerHCP"
          />
        </v-card>
      </div>
    </v-row>
    <v-overlay
      :value="overlay"
      @update:value="overlay = $event"
      class="d-flex align-star justify-center"
      style="z-index: 1000; position: absolute"
    >
      <v-row class="d-flex justify-center my-5">
        <v-card min-height="200" width="70%" class="secundary6">
          <v-card-title class="text-body-1 font-weight-bold justify-center">
            Aviso
          </v-card-title>
          <v-card-text class="text-body-2">
            {{ overlayMessage }}
          </v-card-text>
          <v-card-actions class="mx-auto mb-5">
            <v-btn
              color="primary"
              class="d-flex mx-auto justify-center"
              @click="toggleOverlay()"
            >
              IR A INDEX
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-row>
    </v-overlay>
    <v-snack-bar :snackbar="snackbar" />
  </v-container>
</template>

<script>
import apiClient from '@/api/apiClient.js';
import { mapGetters, mapActions } from 'vuex';
import MainHeaderPlatA from '@/components/includes/MainHeaderPlatA.vue';
import MainHeaderPlatB from '@/components/includes/MainHeaderPlatB.vue';
import VNavDrawAnam from '@/components/base/VNavDrawAnam.vue';
import VCardFormAnamCo from '@/components/base/VCardFormAnamCo.vue';
import VSlidesCo from '@/components/base/VSlidesCo.vue';
import VSnackBar from '@/components/base/VSnackBar.vue';

export default {
  name: 'Co15Page',
  components: {
    MainHeaderPlatA,
    MainHeaderPlatB,
    VNavDrawAnam,
    VCardFormAnamCo,
    VSlidesCo,
    VSnackBar,
  },
  data() {
    return {
      overlay: false,
      overlayMessage: '',
    };
  },
  mounted() {
    this.loadData();
  },
  computed: {
    ...mapGetters('testCOx15', ['schema', 'coModel', 'status']),
    ...mapGetters('testCOxResults', ['overlayCal']),
    ...mapGetters('anamPermissions', ['anamIndex', 'anamGroupShow', 'hasPermission', 'observerHCP']),
    ...mapGetters('notifications', ['snackbar']),
  },
  methods: {
    ...mapActions('testCOx15', ['loadSchema', 'loadModelForm']),
    ...mapActions('testCOxResults', ['coResultDownload', 'toggleOverlayCal']),
    ...mapActions('anamPermissions', ['loadPermissionsHCP', 'sectionsHCPandRoute', 'checkPermission', 'loadObserverHCP']),
    ...mapActions('notifications', ['triggerSnackbar']),

    async loadData() {
      await this.$store.dispatch('testCOxResults/toggleOverlayCal', true);
      try {
        await Promise.all([
          this.loadSchema(),
          this.sectionsHCPandRoute(this.$route),
        ]);

        if (this.hasPermission) {
          await this.loadModelForm();
        } else {
          this.overlay = true;
          this.overlayMessage = 'No tiene acceso a esta sección. Solicite permisos.';
        }
      } catch (error) {
        this.handleDataError(error, 'Error al cargar datos.');
      } finally {
        await this.$store.dispatch('testCOxResults/toggleOverlayCal', false);
      }
    },

    handleEvents() {},

    async btnResult() {
      this.$store.commit('auth/setCoNum', parseInt('15'));
    },

    async ageVerifAndSave() {
      if (this.coModel.coInfo.coDateEva !== '') {
        const id = this.$store.state.auth.authData.clinicalHistories_id;
        const res = await apiClient.getModelIdent(id);
        let modelIdent = res.data.data;

        const birthYear = parseInt(modelIdent.group2.users_birth_date_year);
        const birthMonth = parseInt(modelIdent.group2.users_birth_date_month);
        const birthDay = 15; 

        const patientBirthDate = new Date(birthYear, birthMonth - 1, birthDay);
        const coDateEva = new Date(this.coModel.coInfo.coDateEva);

        let coEvalAgeYears = coDateEva.getFullYear() - patientBirthDate.getFullYear();
        const monthDiff = coDateEva.getMonth() - patientBirthDate.getMonth();
        
        if (monthDiff < 0 || (monthDiff === 0 && coDateEva.getDate() < patientBirthDate.getDate())) {
          coEvalAgeYears--;
        }

        if (13 <= coEvalAgeYears && coEvalAgeYears <= 18) {
          this.save();
        } else {
          if (
            confirm(
              'Edad fuera de rango. La edad debe ser de 13 a 18 años. Si desea continuar, el rango se extenderá de 12 a 19 años'
            )
          ) {
            if (12 <= coEvalAgeYears && coEvalAgeYears <= 19) {
              this.save();
            } else {
              alert('Edad fuera de rango para este corrector');
            }
          }
        }
      } else {
        alert('No ha ingresado la fecha de evaluación');
      }
    },

    async save() {
      let model = {};
      model.modelForm = this.coModel.modelForm;
      this.$store.commit('auth/setCoNum', parseInt('15'));
      model.instProfesId = this.$store.state.auth.authData.institutions_profes_id;
      model.coNew = this.$store.state.auth.authData.coNew;
      model.coDateEva = this.coModel.coInfo.coDateEva;
      model.coBaremo = this.coModel.coInfo.coBaremo;
      model.clinicalHistories_id = this.$store.state.auth.authData.clinicalHistories_id;
      model.coNumId = this.$store.state.auth.authData.coNumId;

      let group1 = model.modelForm[0].modelForm.group1;
      let ItemsGroup1 = { ...group1 };
      if (Object.keys(ItemsGroup1).length > 7) {
        try {
          await this.$store.dispatch('testCOxResults/toggleOverlayCal', true);
          await this.$store.dispatch('testCOx15/save', model);
          this.snackbarOpen();
        } catch {
          this.snackbarOpen();
        } finally {
          await this.$store.dispatch('testCOxResults/toggleOverlayCal', false);
          this.reload();
        }
      } else {
        alert('Ingrese las respuestas de los items');
      }
    },

    toggleOverlay() {
      this.overlay = !this.overlay;
      if (!this.overlay && this.$route.name !== 'index') {
        this.$router.replace({ name: 'index' });
      }
    },

    reload() {
      this.loadModelForm();
      this.modelCoDate = {};
    },

    snackbarOpen() {
      this.snackbar.visible = false;
      if (this.status === 'success') {
        this.snackbar.visible = true;
        this.snackbar.content = this.schema.snackOk;
      } else if (this.status === 'error') {
        this.snackbar.visible = true;
        this.snackbar.content = this.schema.snackError;
      }
    },
  },
};
</script>

<style>
.barLateral {
  min-width: 60px;
}

.contentCentral {
  width: 96%;
}

.contentCardCentral {
  width: 98.5%;
  margin-top: 90px;
}

.contentRowCentral {
  width: 80%;
  min-height: 400px;
}

.bannerAction {
  width: 87%;
  height: 48px;
}

.v-carousel__controls__item {
  color: grey !important;
}
</style>
